import { render, staticRenderFns } from "./EntregaUpdate.vue?vue&type=template&id=1447ce07"
import script from "./EntregaUpdate.vue?vue&type=script&lang=js"
export * from "./EntregaUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports